module.exports = __webpack_public_path__ + "img/home-rbn-10.fb24e21a.png";